<template>
  <div class="terms">
    <Header/>
    <Banner
      image="hero-image@2x.jpg"
      alt=""
    />
    <!-- eslint-disable -->
    <div class="wrapper">
      <h1 class="legal__title">
        TERMS AND CONDITIONS.
        <br>
        <strong class="legal__author">Retail Prodigy Group Pty Ltd &mdash; ACN 149 570 801</strong>
      </h1>
      <section class="legal">
        <div class="tc__summary">
          <h2>SUMMARY</h2>
          <p class="legal__text">
            We are committed to ensuring that the privacy of your <em>personal information</em> is respected and maintained at all-times. We are bound by the Australian Privacy Principles in the Privacy Act 1988 (Cth).
          </p>
          <p class="legal__text">
            The Terms and Conditions outlines how we manage your <em>personal information</em> and how we collect, hold, use and disclose that information.
          </p>
          <p class="legal__text">
            The Terms and Conditions document outlines how the Retail Prodigy Group Rewards Program and Returns Policy is managed and governed in participating Nike stores in Australia and New Zealand.
          </p>
        </div>
        <div class="tc__definitions">
          <h2>DEFINITIONS</h2>
          <p class="legal__text">
            These words when used in this Terms and Conditions have the following specific meanings:
          </p>
          <p class="legal__text">
            <strong>APPs &mdash;</strong> means the Australian Privacy Principles in the Privacy Act.
          </p>
          <p class="legal__text">
            <strong>Member &mdash;</strong> means an individual who joined the Rewards Program of Retail Prodigy Group
          </p>
          <p class="legal__text">
            <strong>Member Profile &mdash;</strong> means the personal profile of the member
          </p>
          <p class="legal__text">
            <strong>Join Date &mdash;</strong> means the date a member joins the Rewards Program
          </p>
          <p class="legal__text">
            <strong>Participating Stores &mdash;</strong> means the Nike stores participating in the Rewards Program owned and operated in Australia and New Zealand by <strong>Retail Prodigy Group Pty Ltd &mdash; ACN 149 570 801</strong>
          </p>
          <p class="legal__text">
            <strong>Personal information &mdash;</strong> has the same meaning as in section 6 of the Privacy Act, which, for ease of reference, means information or an opinion about an identified individual or an individual who is reasonably identifiable:
          </p>
          <p class="legal__text">
            (a)&nbsp;&nbsp;&nbsp;&nbsp;whether the information or opinion is true or not; and
          </p>
          <p class="legal__text">
            (b)&nbsp;&nbsp;&nbsp;&nbsp;whether the information or opinion is recorded in a material form or not,
          </p>
          <p class="legal__text">
            and <em>personal information</em> includes <em>sensitive information</em>.
          </p>
          <p class="legal__text">
            <strong>Points &mdash;</strong> means the rewards points used to calculate if a member qualifies for a Reward Voucher. 1 point = $10.
          </p>
          <p class="legal__text">
            <strong>Points Balance &mdash;</strong> means the points balance at any given point of time by a member earned from purchasing behaviour.
          </p>
          <p class="legal__text">
            <strong>Privacy Act</strong>- means the Privacy Act 1988 (Cth).
          </p>
          <p class="legal__text">
            <strong>Retail Prodigy Group Pty Ltd &mdash;</strong> means the company who manages and operates the Rewards Program in participating Nike stores in Australia and New Zealand.
          </p>
          <p class="legal_text">
            <strong>Returns &mdash;</strong> means the returns policy for customer purchases from Retail Prodigy Group Pty Ltd.
          </p>
          <p class="legal__text">
            <strong>Rewards &mdash;</strong> means rewards or other benefits given to Members as a consequence of purchasing behaviours or incentives.
          </p>
          <p class="legal__text">
            <strong>Rewards Program &mdash; </strong>means the Rewards Program operated by Retail Prodigy Group Pty Ltd.
          </p>
          <p class="legal__text">
            <strong>Rewards Program Terms and Conditions &mdash;</strong> means the Terms and Conditions that govern the Rewards Program operated by Retail Prodigy Group Pty Ltd.
          </p>
          <p class="legal__text">
            <strong>Rewards Voucher &mdash;</strong> means the voucher sent to a member who qualifies for a reward.
          </p>
          <p class="legal__text">
            <strong>$50 Rewards Voucher &mdash;</strong> means the voucher sent to a member who achieved 50 points or more.1 point = $10 therefore a member needs to spend $500 or more to receive a $50 Reward Voucher.
          </p>
          <p class="legal__text">
            <strong>Rewards Voucher Expiry Date &mdash;</strong> means the date the Rewards Voucher expires and can no longer be redeemed.
          </p>
          <p class="legal__text">
            <strong>Sensitive information &mdash;</strong> has the same meaning as in section 6 of the Privacy Act which, for ease of reference, means information or an opinion about your racial or ethnic origin, political opinions, membership of a political association, religious beliefs or affiliations, philosophical beliefs, membership of a professional or trade association, membership of a trade union, sexual orientation or practices, criminal record, health information, genetic information, biometric information for automated verification or identification purposes and biometric templates.
          </p>
          <p class="legal__text">
            <strong>Valid Purchases &mdash;</strong> means all purchases which qualify to earn points in the Rewards Program. Valid purchases include full price and discounted transactions including Openpay but excludes Gift Card transactions.
          </p>
          <p class="legal__text">
            <strong>We</strong>, <strong>our</strong>, or <strong>us &mdash;</strong> means Retail Prodigy Group Pty Ltd ACN 149 570 801 and each of its related bodies corporate.
          </p>
          <p class="legal__text">
            <strong>You</strong> or <strong>your &mdash; </strong>means authorised distributors, retail customers, service providers, contractors, job applicants (or any individual personnel of those foregoing persons) and any other individuals whose <em>personal information</em> we may collect, disclose, use or otherwise handle.
          </p>
        </div>
      </section>
      <section class="legal">
        <div ref="legal__1" id="legal__1" class="legal__1">
          <h2>1.0 &mdash; GENERAL</h2>
          <h3 class="legal__title--h3"><strong>1.1 &mdash; Dealing with us anonymously</strong></h3>
          <p class="legal__text">
            You have the option of not identifying yourself or using a pseudonym when dealing with us unless we are required by law or a court or tribunal to deal with individuals who have identified themselves or it is impractical for us to deal with you if you have not identified yourself. However, if you do so, you may not be able to access, or use, all or part of our goods and services.
          </p>
          <h3 class="legal__title--h3">1.2 &mdash; Direct marketing</h3>
          <p class="legal__text">
            From time to time we may use your <em>personal information</em> to provide you with marketing materials in relation to offers, specials, products and services that we have available. We will not collect, use or disclose your <em>sensitive information</em> for the purpose of direct marketing without your written consent. You may opt out of receiving marketing communications from us at any time by following opt out/unsubscribe instructions provided in such marketing communications.
          </p>
          <h3 class="legal__title--h3">Accuracy of your <em>personal information</em></h3>
          <p class="legal__text">
            While we will endeavour to ensure that the <em>personal information</em> collected from you is up to date, accurate and complete, we will assume that any <em>personal information</em> provided by you is free from errors and omissions. You may request that we update or vary <em>personal information</em> that we hold about you using the contact details set out below. In some circumstances where we correct a record, we may still require the retention of the original record.
          </p>
          <h3 class="legal__title--h3">1.4 &mdash; Requesting access to your <em>personal information</em></h3>
          <p class="legal__text">
            You may obtain access to <em>personal information</em> which we hold about you by contacting us using the contact details set out below. When you request copies of your <em>personal information</em> held by us, we will endeavour to provide you with such <em>personal information</em> as soon as reasonably practicable, provided however that there may be occasions when access to personal information we hold about you is denied. Such occasions would include where release of the information would have an unreasonable impact on the privacy of others. If we refuse to provide you with access to or correct your personal information, we will provide you with an explanation in writing.
          </p>
          <p class="legal__text">
            We may require you to verify your identity and specify what information you require. We will give you reasons if we deny access.
          </p>
          <p class="legal__text">
            We ask that requests for access to <em>personal information</em> be made inwriting. Photo identification may be required. A fee will not apply to making a request for access to your personal information. A fee may apply and be charged to cover our costs in collating, copying and providing certain information to you.
          </p>
          <h3 class="legal__title--h3">1.5 &mdash; Making a complaint about a breach of your privacy rights</h3>
          <p class="legal__text">
            If you are of the view we have breached the APPs, the Privacy Act, or any related privacy code in dealing with your <em>personal information</em>, you may make a complaint by writing to us using the contact details set out below and we will endeavour to provide you with confirmation as to how we propose to deal with the complaint as soon as reasonably practicable.
          </p>
          <p class="legal__text">
            If you are not satisfied with our response to your complaint, you may make a complaint to the Office of the Australian Information Commissioner by visiting the following website and following the steps: <a href="https://www.oaic.gov.au/individuals/how-do-i-make-a-privacy-complaint" target="_blank"> https://www.oaic.gov.au/individuals/how-do-i-make-a-privacy-complaint</a>
          </p>
          <h3 class="legal__title--h3">1.6 &mdash; Changes to our Terms and Conditions</h3>
          <p class="legal__text">
            We reserve the right to change this policy at any time. The updated policy will be available on this website <a target="_blank" href="http://www.retailprodigygroup.com">www.retailprodigygroup.com</a>.
          </p>
          <p class="legal__text">
            <strong>1.7 &mdash; </strong>Individuals who join the Rewards Program agree to be bound by the Terms and Conditions.
          </p>
          <p class="legal__text">
            <strong>1.8 &mdash;</strong> The Terms and Conditions may be modified at any time without prior notification by Retail Prodigy Group. Any changes or modifications to the Terms and Conditions may be applied retrospectively.
          </p>
          <p class="legal__text">
            <strong>1.9 &mdash;</strong> Retail Prodigy Group will not accept any liability for any technical issues that may impact the operation of the Rewards Program.
          </p>
          <p class="legal__text">
            <strong>1.10 &mdash;</strong> Retail Prodigy Group may collect personal information from Members for the purpose of facilitating the Rewards Program.
          </p>
          <p class="legal__text">
            <strong>1.11 &mdash;</strong> Retail Prodigy Group reserves the right to cancel, terminate, modify or suspend the Rewards Program at any time without notice.
          </p>
          <p class="legal__text">
            <strong>1.12 &mdash;</strong> Retail Prodigy Group will not be liable for any tax liability incurred by a member in connection with the Rewards Program.
          </p>
          <h3 class="legal__title--h3 visuallyhidden">1.13</h3>
          <p class="legal__text">
            <strong>1.13 &mdash;</strong> Retail Prodigy Group decision in relation to all matters arising in relation to the Rewards Program will be binding.
          </p>
        </div>
        <div ref="legal__2" id="legal__2" class="legal__2">
          <h2>2.0 &mdash; REWARDS PROGRAM MEMBERSHIP</h2>
          <p class="legal__text">
            <strong>2.1 &mdash;</strong> Membership of the Rewards Program is open to individuals who are 18 years or older with an active email address.
          </p>
          <p class="legal__text">
            <strong>2.2 &mdash;</strong> An individual becomes a member as at the Join Date.
          </p>
          <p class="legal__text">
            <strong>2.3 &mdash;</strong> An individual is deemed to be a member when they join the Rewards Program in store.
          </p>
          <p class="legal__text">
            <strong>2.4 &mdash;</strong> When joining in-store a team member will record as a minimum the full name and email address. An individual may update their Member Profile and manage their preferences via Manage Preferences link in marketing communications.
          </p>
          <p class="legal__text">
            <strong>2.5 &mdash;</strong> At any time members may only have one account to the Rewards Program.
          </p>
          <p class="legal__text">
            <strong>2.6 &mdash;</strong> Members may not transfer their account or Rewards to another person.
          </p>
          <p class="legal__text">
            <strong>2.7 &mdash;</strong> Retail Prodigy Group reserves the right to modify, refuses or terminate a members account to the Rewards Program.
          </p>
          <p class="legal__text">
            <strong>2.8 &mdash;</strong> A member may end their membership of the Rewards Program at any time by unsubscribing using the links in marketing communications or by contacting Retail Prodigy Group Pty Ltd on 03 9530 5016 or email <a target="_blank" href="mailto:info@retailprodigygroup.com">info@retailprodigygroup.com</a>.
          </p>
          <p class="legal__text">
            <strong>2.9 &mdash;</strong> By joining the Rewards Program an individual consent's to Retail Prodigy Group Pty Ltd and Nike Inc contacting them with customer and marketing information and notifying them of Rewards or other products, events and special offers.
          </p>
        </div>
        <div ref="legal__3" id="legal__3" class="legal__3">
          <h2>3.0 &mdash; EARNING AND REDEEEMING REWARDS</h2>
          <p class="legal__text">
            <strong>3.1 &mdash;</strong> Members earn points based on making valid purchases.
          </p>
          <p class="legal__text">
            <strong>3.2 &mdash;</strong> Members are required to earn 50 points or more to receive a Rewards Voucher of $50. 1 point = $10 therefore a member needs to spend $500 or more to receive a $50 Reward Voucher.
          </p>
          <p class="legal__text">
            <strong>3.3 &mdash;</strong> Where a valid purchase is made in-store points will be allocated to the member Rewards Program account on the day the transaction is made.
          </p>
          <p class="legal__text">
            <strong>3.4 &mdash;</strong> The currency in which Reward are earned will be based on your country of residence as follows AUS = AUD, NZ = NZD.
          </p>
          <p class="legal__text">
            <strong>3.5 &mdash;</strong> Rewards cannot be sold, transferred or assigned and are not redeemable for cash.
          </p>
          <p class="legal__text">
            <strong>3.6 &mdash;</strong> Rewards cannot be used for purchases on Nike.com.
          </p>
          <p class="legal__text">
            <strong>3.7 &mdash;</strong> Rewards can only be used at a Rewards Program participating store operated by Retail Prodigy Group.
          </p>
          <p class="legal__text">
            <strong>3.8 &mdash;</strong> Specific terms and conditions relating to the use of Reward Vouchers will be clearly included in the Reward Voucher email sent to the member.
          </p>
          <p class="legal__text">
            <strong>3.9 &mdash;</strong> When a member returns a purchase for a return the net amount of the transaction will be deducted from the members points balance.
          </p>
          <p class="legal__text">
            <strong>3.10 &mdash;</strong> Some exclusions may apply when redeeming Reward Vouchers.
          </p>
          <p class="legal__text">
            <strong>3.11 &mdash;</strong> Members must show their Rewards Voucher in-store to redeem them.
          </p>
          <p class="legal__text">
            <strong>3.12 &mdash;</strong> If a member doesn't spend the total of the Reward Voucher a Credit Voucher will be issued for the balance.
          </p>
          <p class="legal__text">
            <strong>3.13 &mdash;</strong> Rewards Voucher cannot be used in conjunction with any other offer.
          </p>
          <p class="legal__text">
            <strong>3.14 &mdash;</strong> All Reward Vouchers have an expiry date and must be used by that expiry date.
          </p>
        </div>
        <div ref="legal__4" id="legal__4" class="legal__4">
          <h2>4.0 &mdash; SALES AND DELIVERY</h2>
          <p class="legal__text">
            <strong>4.1 &mdash;</strong> All payments need to be made in full before any goods are despatched
          </p>
          <p class="legal__text">
            <strong>4.2 &mdash;</strong> We reserve the right to extend, cancel or change any promotional offer, discount or coupon at any time.
          </p>
          <p class="legal__text">
            <strong>4.3 &mdash;</strong> We will supply the goods as shown on <a target="_blank" href="http://www.shopnikestores.com">www.shopnikestores.com</a> following confirmation of your order.
          </p>
          <p class="legal__text">
            <strong>4.4 &mdash;</strong> We will use our best endeavours to meet delivery timeframes but cannot guarantee delivery timeframes will be met.
          </p>
          <p class="legal__text">
            <strong>4.5 &mdash;</strong> In the event we cannot fulfil your order we will provide a full refund.
          </p>
          <p class="legal__text">
            <strong>4.6 &mdash;</strong> Only credit cards payment options are currently available on <a target="_blank" href="http://www.shopnikestores.com">www.shopnikestores.com</a>
          </p>
          <p class="legal__text">
            <strong>4.7 &mdash;</strong> Prices for our products are subject to change without notice.
          </p>
          <p class="legal__text">
            <strong>4.8 &mdash;</strong> If you have any questions regarding your purchase or delivery please contact <a target="_blank" href="mailto:info@retailprodigygroup.com">info@retailprodigygroup.com</a> and we will respond to your query asap.
          </p>
          <h3 class="legal__title--h3">PRODUCT LAUNCHES</h3>
          <p class="legal__text">
            <strong>4.9 &mdash;</strong> Specific terms and conditions apply to Launches of new product including Basketball shoe launches as per below;
          </p>
          <p class="legal__text">
            <strong>4.9.1 &mdash;</strong> Only 1 product per customer.
          </p>
          <p class="legal__text">
            <strong>4.9.2 &mdash;</strong> Free standard delivery within a state in AUS if ordered via <a target="_blank" href="http://www.shopnikestores.com">www.shopnikestores.com</a>
          </p>
          <p class="legal__text">
            <strong>4.9.3 &mdash;</strong> Delivery charges apply if delivery is required interstate. Stores will contact customers to confirm delivery charge and process payment.
          </p>
          <p class="legal__text">
            <strong>4.9.10 &mdash;</strong> Customer will receive a confirmation email from the store where the product is ordered from once the store confirms the requested product is available for delivery.
          </p>
          <p class="legal__text">
            <strong>4.9.11 &mdash;</strong> Customer must be a Nike Member to purchase new launch product. If at the time the customer orders product via <a target="_blank" href="http://www.shopnikestores.com">www.shopnikestores.com</a> and is not a Nike Member the customer membership will be created instore by Retail Prodigy Group.
          </p>
          <p class="legal__text">
            <strong>4.9.12 &mdash;</strong> Product sizing is subject to strictly limited availability and allocated on a first in basis.
          </p>
          <p class="legal__text">
            <strong>4.9.13 &mdash;</strong> Retail Prodigy Group reserves the right to allocate inventory based on eligible orders/reservations received.
          </p>
          <p class="legal__text">
            <strong>4.9.14 &mdash;</strong> Orders cannot be assigned or transferred to anyone else.
          </p>
          <p class="legal__text">
            <strong>4.9.15 &mdash;</strong> All Launch product is subject to availability and Retail Prodigy Group is under no obligation to provide an alternative product.
          </p>
          <p class="legal__text">
            <strong>4.9.16 &mdash;</strong> If a customer orders a Launch Product and the product is not available the customer will receive a refund to the same credit card the customer used to place the order.
          </p>
          <p class="legal__text">
            <strong>4.9.17 &mdash;</strong> Retail Prodigy Group accepts no responsibility for any loss, damage, liability, injury or loss incurred or suffered by you as a result of ordering or purchasing a new product launch.
          </p>
          <p class="legal__text">
            <strong>4.9.18 &mdash;</strong> If an eligible Nike Member violates any of these terms and conditions an alternative eligible Nike Member will be selected at retail Prodigy Group discretion.
          </p>
        </div>
        <div ref="legal__5" id="legal__5" class="legal__5">
          <h2>5.0 &mdash; RETURNS</h2>
          <p class="legal__text">
            <strong>5.1 &mdash;</strong> We will provide an exchange, credit note or refund in the situation that a product is deemed faulty, change of mind or exchanging a gift.
          </p>
          <p class="legal__text">
            <strong>5.2 &mdash;</strong> Proof of purchase from Retail Prodigy Group is required for all exchanges, credit notes and refunds.
          </p>
          <p class="legal__text">
            <strong>5.3 &mdash;</strong> If an item was discounted at the time of purchase and a refund is issued then the amount returned will be the discounted amount.
          </p>
          <p class="legal__text">
            <strong>5.4 &mdash;</strong> If an item is returned then it will be returned to the same tender.
          </p>
          <p class="legal__text">
            <strong>5.5 &mdash;</strong> If there is no proof of purchase then only a credit-note or exchange option will be available and will be at the managers discretion.
          </p>
          <p class="legal__text">
            <strong>5.6 &mdash;</strong> To return product customers will need to send an email to <a target="_blank" href="mailto:info@retailprodigygroup.com">info@retailprodigygroup.com</a> and we will respond asap with instructions on the return process.
          </p>
          <p class="legal__text">
            <strong>5.7 &mdash;</strong> Due to hygiene reasons we are unable to accept returns for men's underwear if it is for change of mind or incorrect size.
          </p>
          <p class="legal__text">
            <strong>5.8 &mdash;</strong> If a product is purchased online at <a href="https://www.shopnikestores.com/" target="_blank">www.shopnikestores.com</a>, customers can return or exchange product in-store at any Retail Prodigy Group Nike store.
          </p>
          <p class="legal__text">
            <strong>5.9 &mdash;</strong> If a customer has purchased a product online is unable to return in-store, please contact <a target="_blank" href="mailto:info@retailprodigygroup.com">info@retailprodigygroup.com</a> and we will respond asap with instructions on the return process via post or pick-up option.
          </p>
          <p class="legal__text">
            <strong>5.10 &mdash;</strong> If a purchase requires a refund after being purchased using a Buy Now Pay Later payment option; Afterpay, Openpay, Zip Pay, Klarna, you will need to complete the Retail Prodigy Group returns process as normal and payment refunds will be subject to the individual payment merchant’s policy.
          </p>
        </div>
        <div ref="legal__6" id="legal__6" class="legal__6">
          <h2>6.0 &mdash; FAQS</h2>
          <p class="legal__text">
            <strong>6.1 &mdash; What types of <em>personal information</em> do we collect?</strong>
          </p>
          <p class="legal__text">
            <strong>We generally collect and hold:</strong>
            <br>
            Your name, date of birth, gender, postal and email address, telephone, interests, purchase history, information obtained from any form or application which we may ask you to complete (whether electronic or paper-based), and other information we consider necessary to provide our goods or services to you.
          </p>
          <p class="legal__text">
            <strong>6.2 &mdash; How do we collect and hold your <em>personal information</em>?</strong>
          </p>
          <p class="legal__text">
            We generally obtain <em>personal information</em> about you by collecting it:
          </p>
          <p class="legal__text">
            <strong>Directly from you:</strong>
            <br>
            For example, via forms you complete for us, and through your interactions with us and our staff as
            well as via our websites, over the phone, via email or in person.
          </p>
          <p class="legal__text">
            We will not collect <em>sensitive information</em> about you without first obtaining your consent. Unless one of the limited exemptions under the Privacy Act applies, we will only collect your <em>sensitive information</em> if you consent to such collection and if such <em>sensitive information</em> is reasonably necessary for one or more of our functions or activities.
          </p>
          <p class="legal__text">
            We hold your <em>personal information</em> in various ways, including in paper and electronic form. We take reasonable steps to protect your <em>personal information</em> from misuse, loss, unauthorised access, modification and disclosure including through implementation of password protected digital storage solutions as well as keeping paper forms insecure filing systems.
          </p>
          <h3 class="legal__title--h3">6.3 &mdash; For what purposes do we use <em>personal information</em>?</h3>
          <p class="legal__text">
            Unless you consent otherwise or where we are otherwise permitted to do so by law, <em>personal information</em> will only be used for the purposes for which it was provided (<strong>primary purpose</strong>) or for a purpose (<strong>secondary purpose</strong>) related, or in the case of <em>sensitive information</em> directly related, to the primary purpose. Some examples of the purposes we ordinarily use <em>personal information</em> for are detailed below.
          </p>
          <p class="legal__text">
            Generally, we will use your <em>personal information</em>: 
          </p>
          <ul class="list">
            <li>to provide you with requested goods or services (including contacting you and our delivery agents to make delivery or payment arrangements, issue reminders or arrange returns, contact you concerning the status of an order/purchase, answer questions, respond to your inquiries or requests).</li>
            <li>for our internal management purposes, to manage our relationship with you, personalise and improve our services, our websites and stores and to manage the payment and recovery of amounts payable to us by you.</li>
            <li>to enable us to conduct our business generally, such as notifying our freight and shipping contractors or our insurers, undertaking quality assurance, internal teaching and data processing and handling.</li>
            <li>to tell you about our products or services that might better service your business or personal requirements or other opportunities in which you may be interested.</li>
            <li>to comply with any law.</li>
            <li>for other purposes which are reasonably necessary in connection with our normal functions and activities.</li>
          </ul>
          <h3 class="legal__title--h3">6.4 &mdash; Who will we disclose your <em>personal information</em> to?</h3>
          <p class="legal__text">
            Generally, we may disclose your <em>personal information</em>:
          </p>
          <ul class="list">
            <li>to any person you consent to receiving such information (e.g. when you place an order with us, you consent to us providing your name and delivery address to our delivery contractors to enable delivery)</li>
            <li>to our staff and management (e.g. for business decision, data processing, marketing and administrative purposes)</li>
            <li>to our service providers, advisors and contractors who assist us in operating our business (e.g. IT service providers) or who assist us in providing products or services to you (e.g. our freight and shipping contractors or insurers)</li>
            <li>to any person we are required or authorised by law to disclose your <em>personal information</em></li>
          </ul>
          <p class="legal__text">
            We do not ordinarily disclose your <em>personal information</em> to overseas recipients.
          </p>
        </div>
        <!-- <div ref="legal__7" id="legal__7" class="legal__7">
          <h2>7.0 &mdash; <template v-for="(raffle, index) in raffles"><span :key="`raffle-heading-${raffle.sku ? raffle.sku : index}`">{{ raffle.name }}{{ raffle.sku ? ` &mdash; ${raffle.sku}` : '' }}{{ index !== raffleQty - 1 ? ', ' : '' }}</span></template> &mdash; {{ raffleDateTime }}.</h2>
          <template v-for="(raffle, index) in raffles">
            <p class="legal__text" :key="`raffle-details-${raffle.sku}p`">
              <strong>7.{{ index + 1 }} &mdash; {{ raffle.name }}{{ raffle.sku ? ` &mdash; ${raffle.sku}` : '' }} "Schedule"</strong>
            </p>
            <div class="legal__text table-wrap" :key="`raffle-details-${raffle.sku}tb`">
              <table class="table">
                <tbody>
                  <tr>
                    <td class="td td-title">Raffle name</td>
                    <td class="td">
                      <template v-for="(collection, nKey, index) in raffle.collections">
                        <strong v-for="(shoe, snKey) in collection.shoes" :key="`raffle-shoename-${index}${snKey}`">
                          {{ shoe.sku }} {{ shoe.name }}
                        </strong>{{ index !== Object.keys(raffle.collections).length - 1 ? ',' : '' }}
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td class="td td-title">Eligible Countries/States/Territories</td>
                    <td class="td">{{ raffle.states }}</td>
                  </tr>
                  <tr>
                    <td class="td td-title">Promotion period for Raffle</td>
                    <td class="td">
                      <template v-for="(collection, cKey) in raffle.collections">
                        <div :key="`raffle-collections-${cKey}`">
                          <strong>{{ cKey }} &mdash; <span v-html="collection.entryPeriod"></span> {{ collection.entryPeriodTime }}</strong>
                        </div>
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td class="td td-title">Promoter</td>
                    <td class="td">
                      Retail Prodigy Group Pty Ltd<br><br>ABN: 43 854 395 125<br><br>Address: Level 1, 19 Carpenter Street<br>Brighton, Victoria 3186
                    </td>
                  </tr>
                  <tr>
                    <td class="td td-title">Promoter Contact Details</td>
                    <td class="td">Email &mdash; <a href="mailto:info@retailprodigygroup.com">info@retailprodigygroup.com</a></td>
                  </tr>
                  <tr>
                    <td class="td td-title">Eligible entrants</td>
                    <td class="td">Entry to the Raffle is open to Australian residents in all eligible states/territories who fulfil the method of entry requirements and are 18 years of age or older.</td>
                  </tr>
                  <tr>
                    <td class="td td-title">Details of Raffle</td>
                    <td class="td">
                      <template v-for="(collection, cDKey, index) in raffle.collections">
                        <p :key="`raffle-details-${cDKey}`">
                          <strong>{{ cDKey }}</strong><br>Raffle entries open at <strong v-html="collection.start"></strong> and close at <strong v-html="collection.close"></strong><br>Retail Prodigy Group reserves the right to close the raffle prior to <strong v-html="collection.close"></strong>.<br><br>
                        </p>
                      </template>
                    </td>
                  </tr>
                  <tr>
                    <td class="td td-title">Method of entry</td>
                    <td class="td">Members ONLY can enter the raffle 1 time and must enter via the email link sent on <template v-for="(collection, cEKey, index) in raffle.collections"><span :key="`raffle-email-sent-${cEKey}`"><strong v-html="collection.emailTime"></strong><strong> for {{ cEKey }}</strong>{{ index !== Object.keys(raffle.collections).length - 1 ? ', ' : ' and ' }}</span></template> by Retail Prodigy Group to its Members.<br>Entry must be completed between <strong v-html="raffle.entryPeriodTime"></strong>.<br>All fields in the entry form must be completed.</td>
                  </tr>
                  <tr>
                    <td class="td td-title">Maximum number of entries</td>
                    <td class="td">Strictly ONLY 1 entry per Member</td>
                  </tr>
                  <tr>
                    <td class="td td-title">Raffle draw</td>
                    <td class="td">
                      Raffle draw will take place on the following dates:<br><br>
                      <template v-for="(collection, cRKey) in raffle.collections">
                        <strong :key="`raffle-draw-${cRKey}s`">{{ cRKey }} &mdash; <span v-html="collection.drawTime"></span></strong><br :key="`raffle-draw-${cRKey}br`">
                      </template>
                      <br><br>A randomized draw will take place resulting in the winners receiving the option to purchase 1 pair of {{ raffle.sku ? '' : 'the following shoes:' }}<br v-if="!raffle.sku"><strong v-html="getRaffleDraw(raffle)"></strong>{{ raffle.sku ? ' ' : '' }}<br v-if="!raffle.sku">of their requested size only.<br><br>Draw will be completed by state for Australia with the ACT included in the New South Wales draw. New Zealand will be completed as 1 region.<br><br>Location of draw;<br><br>Due to COVID 19 restrictions the draw will take place via Zoom by employees of Retail Prodigy Group.
                    </td>
                  </tr>
                  <tr>
                    <td class="td td-title">Notification of raffle winners</td>
                    <td class="td">Winners will be notified via email by no later than the following times:<br><br>
                    <template v-for="(collection, cWKey) in raffle.collections">
                      <strong :key="`raffle-winner-s${cWKey}`">{{ cWKey }} &mdash; <span v-html="collection.winnerAnnounce"></span></strong><br :key="`raffle-winner-${cWKey}br`">
                    </template>
                    <br>with instructions on how to purchase. Winners will only be offered the size they have requested. No changes can be made to the requested size.</td>
                  </tr>
                  <tr>
                    <td class="td td-title">Purchasing requirements</td>
                    <td class="td">Winners will need to successfully purchase their allocated size, prior to any arrangements being made for delivery or pick up. Winners will need to purchase by the "deadline" which will be:<br><br>
                    <template v-for="(collection, cPKey) in raffle.collections">
                      <strong :key="`raffle-purchase-s${cPKey}`">{{ cPKey }} &mdash; <span v-html="collection.purchaseBy"></span>.</strong><br :key="`raffle-purchase-br${cPKey}`">
                    </template>
                    <br>If the winner doesn't purchase within the deadline provided; they will forfeit their opportunity to purchase.<br>There will be no interstate deliveries or deliveries between Australia and New Zealand.</td>
                  </tr>
                  <tr>
                    <td class="td td-title">Terms and Conditions</td>
                    <td class="td">Terms and Conditions are subject to change without notice</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <p class="legal__text">
            <strong>7.{{ raffleQty + 1 }} &mdash;</strong> Information on how to enter the Raffle details form part of these terms &amp; conditions (Terms of entry). The Terms must be read in conjunction with the Schedule. The Schedule defines the terminology used in these Terms of entry. Where there is any inconsistency between these Terms and the Schedule, the Schedule prevails. Participation in this Raffle is deemed acceptance of these Terms of entry.
          </p>
          <p class="legal__text">
            <strong>7.{{ raffleQty + 2 }} &mdash;</strong> Entry is open only to legal residents of the Eligible Countries/States/Territories who satisfy the Method of entry.
          </p>
          <p class="legal__text">
            <strong>7.{{ raffleQty + 3 }} &mdash;</strong> The Promotion will be conducted during the Promotion period.
          </p>
          <p v-for="(raffle, index) in raffles" :key="`raffle-price-${raffle.sku}`" class="legal__text">
            <strong>7.{{ raffleQty + 4 + index }} &mdash;</strong> <strong>{{ raffle.name }}{{ raffle.sku ? ` &mdash; ${raffle.sku}` : '' }}</strong> retail prices for winners to purchase in <strong>Australian is{{ raffle.price ? ' ' : ':' }}<span v-html="getAUPrice(raffle)"></span>{{ raffle.price ? ' ' : '' }}<br v-if="!raffle.price">and for New Zealand residents is{{ raffle.price ? ' ' : ':' }}<span v-html="getNZPrice(raffle)"></span>.</strong>
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 4 }} &mdash;</strong> The entrants must follow the Method of entry during the Promotion period to enter the Promotion. Failure to do so will result in an invalid entry. The Promoter will not advise an Entrant if their entry is deemed invalid.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 5 }} &mdash;</strong> The time of entry will be deemed to be the time the entry is received by the Promoter.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 6 }} &mdash;</strong> The Promoter accepts no responsibility for any late, lost, delayed, incomplete, incorrectly submitted, corrupted, illegible or misdirected entries, claims or correspondence whether due to omission, error, alteration, tampering, deletion, theft, destruction, disruption to any communication network or medium, or otherwise including those entries not received by the Promoter for any reason. The Promoter is not liable for any consequences of user error including (without limitation) costs incurred. No correspondence will be entered into.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 7 }} &mdash;</strong> The raffle winners will be awarded to the valid entrant drawn randomly in accordance with the Raffle draw details. The Promoter may draw additional reserve entries (and record them in order). In the event of an invalid entry or an ineligible entrant, or if the entrant is unable to complete the purchase, the relevant size will be awarded to the first reserve entry drawn. If the purchase still can't be completed to the entrant drawn, the promoter will then continue this process until all the sizes have been purchased.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 8 }} &mdash;</strong> The winner does not need to be present at the draw unless expressly stated to the contrary.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 9 }} &mdash;</strong> The winner will be notified in accordance with the Notification of Raffle winners.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 10 }} &mdash;</strong> The Promoter takes no responsibility where it is unable to contact raffle winners who have not provided correct or complete contact details. If an entrant's contact details change during the promotional period, it is the entrant's responsibility to notify the Promoter. A request to modify any entry information should be directed to Promoter.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 11 }} &mdash;</strong> To the greatest extent permitted by law, the Promoter excludes all warranties, representations or guarantees (Warranties) regarding the Promotion and any raffle winners purchases, including any Warranties which may have been made while advertising or promoting the Promotion. The conduct of the Promotion and the Promoter makes no Warranties and disclaims all liability in connection with any such third parties, their acts or omissions. By entering the Promotion, an entrant releases and indemnifies the Promoter and its related bodies corporate (including the officers, employees and agents of each) from and against all actions, penalties, liabilities, claims or demands the entrant may have against the Promoter or that the Promoter may incur for any loss or damage which is or may be suffered or sustained as a direct or indirect result of an entrant entering or participating in the Promotion or winning or failing to win a prize, or using or permitting any other person to use the prize, except for any liability which cannot be excluded by law or which would cause any part of this clause to be void or unenforceable.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 12 }} &mdash;</strong> If despite the foregoing clause, the Promoter incurs a liability to an entrant under any law which implies a Warranty into these Terms of entry which cannot legally be excluded, the Promoter's liability in respect of the Promotion is limited, in the Promoter's discretion, to either resupplying such goods or services as form part of the Promotion, or paying the cost of resupplying those goods or services.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 13 }} &mdash;</strong> Without limiting any of the foregoing, in no circumstances will an entrant or the Promoter have any liability to the other for any loss or damage suffered which is indirect or consequential in nature, including without limitation any loss of profit, loss of reputation, loss of goodwill, or loss of business opportunity.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 14 }} &mdash;</strong> The Promoter and its associated agencies and companies will not be liable for any damage in transit to or delay in transit of raffle winners purchase.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 15 }} &mdash;</strong> The Promoter may in its absolute discretion not accept an entry, may disqualify an entry, or cancel the entire Promotion at any time without giving reasons and without liability to any entrants. Without limiting this the Promoter reserves the right to verify the validity of entries, and entrants and to disqualify any entrant who submits an entry or claim that is misleading or not in accordance with these Terms of entry or who manipulates or tampers with the entry process. If a winner breaches these Terms of entry, the winner will forfeit the opportunity to purchase and no substitute will be offered. Verification is at the discretion of the Promoter; whose decision is final. Failure by the Promoter to enforce any of its rights at any stage does not constitute a waiver of those rights.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 16 }} &mdash;</strong> In the case of the intervention of any outside act, agent or event which prevents or significantly hinders the Promoter's ability (or that of a third party involved with the Promotion) to proceed with the Promotion on the dates and in the manner described in these Terms of entry, including but not limited to vandalism, natural disasters, acts of God, civil unrest, strike, war, pandemic, act of terrorism, the Promoter's obligations in respect of the Promotion will be suspended for the duration of the event and, in addition, the Promoter may in its absolute discretion cancel the promotion and recommence it from the start on the same conditions, subject to approval of the relevant authorities.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 17 }} &mdash;</strong> All entries become the property of the Promoter. As a condition of entering this Promotion, entrants agree to assign all their rights in and to their entry and any related content to the Promoter, including any copyright or other intellectual property rights in the entry and related content. Without limiting this, the Promoter may use entry content for all purposes including commercial purposes. You warrant that entry content is original, lawful and not misleading and that the Promoter's use of such content will not infringe the rights of any third parties. The Promoter has no obligation to credit you as the author of any content submitted and may otherwise do any acts or omissions which would otherwise constitute an infringement of any moral rights you may have as an author of content.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 18 }} &mdash;</strong> Entrants consent to the Promoter using the personal information provided in connection with this promotion for the purposes of facilitating the conduct of the promotion and awarding any raffle winners the opportunity to purchase, including to third parties involved in the promotion and any relevant authorities. In addition to any use that may be outlined in the Promoter's Privacy Policy, the Promoter may, for an indefinite period, unless otherwise advised, use the private information for promotional, marketing, publicity, research and profiling purposes, including sending electronic messages or telephoning the entrant.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 19 }} &mdash;</strong> The collection and disclosure of personal information provided in connection with this promotion will be handled in accordance with the Promoter's Privacy statement which adheres to the Privacy Act 1988 (cth) and Australian Privacy Principles.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 20 }} &mdash;</strong> The Promotion and these Terms of entry will be governed by the law of the State or Territory in which the Promoter ordinarily resides. Entrants accept the non-exclusive jurisdiction of courts and tribunals of that State or Territory in connection with disputes concerning the Promotion.
          </p>
          <p class="legal__text">
            <strong>7.{{ (raffleQty * 2) + 21 }} &mdash;</strong> Any questions, comments or complaints regarding the Promotion should be directed to the Promoter via the Promoters contact details.
          </p>
        </div> -->
      </section>
      <section>
        <h2>CONTACT US</h2>
        <p class="legal__text">
          If you wish to request access to your personal information or make a complaint about possible breaches of privacy, or any other issues relating to the Terms and Conditions please direct your enquiries to:
        </p>
        <p class="legal__text">
          <strong>Privacy Officer</strong>
          <br>
          Retail Prodigy Group Pty Ltd
          <br>
          Level 1, 19 Carpenter Street
          <br>
          Brighton, Victoria 3186
          <br>
          Email: info@retailprodigygroup.com.au
          <br>
          Phone: +61 3 9530 5075
        </p>
        <p class="legal__text">
          These Retail Prodigy Group Terms and Conditions were last updated on 16<sup>th</sup> April 2021.
        </p>
      </section>
    </div>
    <!-- eslint-enable -->
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src

// Components
import Header from '@/components/Header.vue';
import Banner from '@/components/Banner.vue';
import Footer from '@/components/Footer.vue';

const raffles = [
  {
    // name: 'CW1590-700 Nike Dunk Low, DA3130-400 Zion 1, DA3130-002 Zion 1, DA3131-002 Zion, DD1869-103 Nike Dunk High, DB2179-103 Nike Dunk High, CW2190-100 Kobe 6 Protro',
    name: 'DD1869-103 Nike Dunk High, DB2179-103 Nike Dunk High, CW2190-100 Kobe 6 Protro',
    states: 'Victoria, New South Wales, Australian Capital Territory, Queensland, Western Australia and New Zealand',
    entryPeriodTime: '9am to 12pm AEST',
    collections: {
      // 'CW1590-700': {
      //   start: '9am AEST Wednesday 5<sup>th</sup> May 2021',
      //   close: '12pm AEST Wednesday 5<sup>th</sup> May 2021',
      //   emailTime: 'Wednesday 5<sup>th</sup> May 2021',
      //   drawTime: 'Wednesday 5<sup>th</sup> May 2021',
      //   winnerAnnounce: 'Thursday 6<sup>th</sup> May 2021 at 11.59pm',
      //   entryPeriod: 'Wednesday 5<sup>th</sup> May 2021',
      //   entryPeriodTime: '9am to 12pm AEST',
      //   purchaseBy: 'Saturday 8<sup>th</sup> May 2021 at 7pm',
      //   shoes: [
      //     {
      //       name: 'Nike Dunk Low (GS)',
      //       sku: 'CW1590-700',
      //       auPrice: 110,
      //       nzPrice: 130,
      //       type: 'Big Kids&#39; Shoe',
      //     },
      //   ],
      // },
      // 'DA3130-400, DA3130-002, DA3131-002': {
      //   start: '9am AEST Monday 3<sup>rd</sup> May 2021',
      //   close: '12pm AEST Monday 3<sup>rd</sup> May 2021',
      //   emailTime: 'Monday 3<sup>rd</sup> May 2021',
      //   drawTime: 'Monday 3<sup>rd</sup> May 2021',
      //   winnerAnnounce: 'Tuesday 4<sup>th</sup> May 2021 at 11.59pm',
      //   entryPeriod: 'Monday 3<sup>rd</sup> May 2021',
      //   entryPeriodTime: '9am to 12pm AEST',
      //   purchaseBy: 'Thursday 6<sup>th</sup> May 2021 at 7pm',
      //   shoes: [
      //     {
      //       name: 'Zion 1',
      //       sku: 'DA3130-400',
      //       auPrice: 170,
      //       nzPrice: 200,
      //       type: 'Basketball Shoe',
      //     },
      //     {
      //       name: 'Zion 1',
      //       sku: 'DA3130-002',
      //       auPrice: 170,
      //       nzPrice: 200,
      //       type: 'Basketball Shoe',
      //     },
      //     {
      //       name: 'Zion 1',
      //       sku: 'DA3131-002',
      //       auPrice: 120,
      //       nzPrice: 140,
      //       type: 'Big Kids&#39; Shoe',
      //     },
      //   ],
      // },
      'DD1869-103, DB2179-103': {
        start: '9am AEST Thursday 29<sup>th</sup> April 2021',
        close: '12pm AEST Thursday 29<sup>th</sup> April 2021',
        emailTime: 'Thursday 29<sup>th</sup> April 2021',
        drawTime: 'Thursday 29<sup>th</sup> April 2021',
        winnerAnnounce: 'Friday 30<sup>th</sup> April 2021 at 11.59pm',
        entryPeriod: 'Thursday 29<sup>th</sup> April 2021',
        entryPeriodTime: '9am to 12pm AEST',
        purchaseBy: 'Sunday 2<sup>nd</sup> May 2021 at 7pm',
        shoes: [
          {
            name: 'Nike Dunk High',
            sku: 'DD1869-103',
            auPrice: 160,
            nzPrice: 190,
            type: 'Women&#39;s Shoe',
          },
          {
            name: 'Nike Dunk High',
            sku: 'DB2179-103',
            auPrice: 120,
            nzPrice: 140,
            type: 'Big Kids&#39; Shoe',
          },
        ],
      },
      'CW2190-100': {
        start: '9am AEST Thursday 29<sup>th</sup> April 2021',
        close: '12pm AEST Thursday 29<sup>th</sup> April 2021',
        emailTime: 'Thursday 29<sup>th</sup> April 2021',
        drawTime: 'Thursday 29<sup>th</sup> April 2021',
        winnerAnnounce: 'Friday 30<sup>th</sup> April 2021 at 11.59pm',
        entryPeriod: 'Thursday 29<sup>th</sup> April 2021',
        entryPeriodTime: '9am to 12pm AEST',
        purchaseBy: 'Sunday 2<sup>nd</sup> May 2021 at 7pm',
        shoes: [
          {
            name: 'Kobe 6 Protro',
            sku: 'CW2190-100',
            auPrice: 250,
            nzPrice: 280,
            type: 'Basketball Shoe',
          },
        ],
      },
    },
  },
];

const raffleDateTime = 'April & May - 2021';

export default {
  name: 'terms',
  components: {
    Header,
    Banner,
    Footer,
  },
  data() {
    return {
      raffles,
      raffleDateTime,
      raffleQty: raffles.length,
    };
  },
  mounted() {
    if (this.$route.hash) {
      this.scrollToSection(this.$route.hash.substring(1));
    }
  },
  methods: {
    scrollToSection(refName) {
      const element = this.$refs[refName];
      const top = element.offsetTop;

      window.scrollTo(0, top);
    },
    getRaffleDraw(raffle) {
      let drawHtml = '';

      if (raffle.sku) {
        drawHtml = `${raffle.name} &mdash; ${raffle.sku}`;
      } else {
        drawHtml = '<br>';

        Object.keys(raffle.collections).forEach((key, index) => {
          raffle.collections[key].shoes.forEach((shoes) => {
            drawHtml = `${drawHtml}${index ? '<br>' : ''}${shoes.sku}<br>${shoes.name}<br>${shoes.type}<br>`;
          });
        });

        drawHtml = `${drawHtml}<br>`;
      }

      return drawHtml;
    },
    getAUPrice(raffle) {
      let auPrices = '';

      if (raffle.price) {
        auPrices = `$${raffle.price} AUD`;
      } else {
        auPrices = '<br>';

        Object.keys(raffle.collections).forEach((key) => {
          raffle.collections[key].shoes.forEach((shoe) => {
            if (shoe.auPrice) {
              auPrices = `${auPrices}<br>${shoe.sku} - $${shoe.auPrice} AUD`;
            }
          });
        });

        auPrices = `${auPrices}<br>`;
      }

      return auPrices;
    },
    getNZPrice(raffle) {
      let nzPrices = '';

      if (raffle.nzPrice) {
        nzPrices = `$${raffle.nzPrice} NZD`;
      } else if (raffle.price) {
        nzPrices = `$${raffle.price} AUD`;
      } else {
        nzPrices = '<br>';

        Object.keys(raffle.collections).forEach((key) => {
          raffle.collections[key].shoes.forEach((shoe) => {
            if (shoe.nzPrice) {
              nzPrices = `${nzPrices}<br>${shoe.sku} - $${shoe.nzPrice} NZD`;
            }
          });
        });
      }

      return nzPrices;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/settings.scss";

// $legal-color: #666;

.visuallyhidden {
  position: absolute !important;
  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
  clip: rect(1px, 1px, 1px, 1px);
  padding: 0 !important;
  border: 0 !important;
  height: 1px !important;
  width: 1px !important;
  overflow: hidden;
}

.legal {
  // color: $legal-color;

  .list {
    margin-bottom: $spacing;

    li {
      line-height: $body-line-height;
    }
  }
}

.list--abc {
  // list-style:
}

.legal__title {
  @include heading('h2');
}

.legal__title--h3 {
  @include heading('p');

  .ui-text {
    font-weight: normal;
  }
}

.legal__author {
  text-transform: none;
}

.legal__text {
  margin: 0 0 $spacing;
  line-height: $body-line-height;
}

.table-wrap {
  width: 800px;
  max-width: 100%;

  .table {
    border-collapse: collapse;
    border-spacing: 0;
    border: none;
  }

  .td {
    width: 70%;
    padding: round($spacing-half / 2);
    border: 1px solid $charcoal-dark;
    font-size: $body-font-size-compressed;
    line-height: $body-line-height;

    @include medium-down {
      display: block;
      width: 100%;
    }
  }

  .td-title {
    width: 30%;
    font-weight: 600;

    @include medium-down {
      display: block;
      width: 100%;
      border-top: none;
      border-bottom: none;
    }
  }

  tr:first-child {
    .td-title {
      border-top: 1px solid $charcoal-dark;
    }
  }
}
</style>
